if (!document.querySelector("#iwm-idempotent-cocre")) {
  $("body").after('<script id="iwm-idempotent-cocre"></' + "script>");
  document.addEventListener("turbo:load", function () {
    $(window).trigger("resize");

    $(".cc-photo-thum").magnificPopup({
      type: "image",
    });

    $(".cc-iframe-popup").magnificPopup({
      type: "iframe",
    });

    $(".cc-iwm-detail-open").on("click", function () {
      $(this).toggleClass("open");
      $(this).next(".cc-iwm-open-item").slideToggle(200);
    });
  });

  document.addEventListener("turbo:frame-load", () => {
    const sth = document.querySelector("[data-scroll-to]");
    if (sth) {
      const to = sth.dataset.scrollTo;
      if (to == "start") {
        // 画面本体のスクロール領域が header 要素の下に隠れているため、
        // `sth.scrollIntoView({block: "start"})` だと対象の要素が header 要素に隠れる位置にスクロールしてしまいます。
        // この問題を回避するために、一回り大きい親要素で scrollIntoView して誤魔化しています。
        sth.closest("turbo-frame,.content-wrapper,body").scrollIntoView();
      } else {
        sth.scrollIntoView({ block: sth.dataset.scrollTo });
      }
    }
  });
}
